import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPlusBoxStack20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconPlusBoxStack20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.75 3.5h7.5c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25H15V7.75A2.75 2.75 0 0 0 12.25 5H6.5v-.25c0-.69.56-1.25 1.25-1.25m7.5 11.5H15v.25A2.75 2.75 0 0 1 12.25 18h-7.5A2.75 2.75 0 0 1 2 15.25v-7.5A2.75 2.75 0 0 1 4.75 5H5v-.25A2.75 2.75 0 0 1 7.75 2h7.5A2.75 2.75 0 0 1 18 4.75v7.5A2.75 2.75 0 0 1 15.25 15m-3-8.5h-7.5c-.69 0-1.25.56-1.25 1.25v7.5c0 .69.56 1.25 1.25 1.25h7.5c.69 0 1.25-.56 1.25-1.25v-7.5c0-.69-.56-1.25-1.25-1.25M8.584 8.389a.75.75 0 0 1 .75.75v1.694h1.527a.75.75 0 0 1 0 1.5H9.334v1.528a.75.75 0 0 1-1.5 0v-1.528H6.139a.75.75 0 0 1 0-1.5h1.694V9.14a.75.75 0 0 1 .75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPlusBoxStack20);
